import 'react-spring-bottom-sheet/dist/style.css';
import MainOddsPopup from '../../components/common/oddsPopup/MainOddsPopup';


export default function AmountPayDueWeb({children}) {
  return (
    <MainOddsPopup>
      {children}
    </MainOddsPopup>
  );
}
